const dateFormatToParts = (date) => {
  return {
    year: date.getFullYear() + '',
    month: ('0' + (date.getMonth() + 1)).slice(-2),
    day: ('0' + date.getDate()).slice(-2),
    hour: ('0' + date.getHours()).slice(-2),
    minute: ('0' + date.getMinutes()).slice(-2),
    seconds: ('0' + date.getSeconds()).slice(-2),
    dayPeriod: date.getHours() >= 12 ? 'pm' : 'am'
  }
}

export default {
  install(Vue) {
    // TODO MVP? Intl account timezones...
    Vue.prototype.$toLocaleYYYYMMDDsH_MMpString = (optDate) => {
      optDate = optDate || new Date()

      const localeDate = dateFormatToParts(optDate)
      return (() => {
        // eslint-disable-next-line no-unused-vars
        var { year, month, day, hour, minute, second, dayPeriod } = localeDate
        return `${year}-${month}-${day} ${hour}_${minute}${dayPeriod}`
      })()
    }
  }
}
